export const getUserNeedTransactionSecondConfirmation = `query getUser{
  getUser{
      need_transaction_second_confirmation
  }
}`;
